<template>
    <v-card>
        <v-toolbar :color="toolbarColor" density="compact">
            <v-toolbar-title
                :style="{
                    minWidth: 'fit-content',
                    color: titleColor,
                }"
            >
                {{ cardTitle }}
            </v-toolbar-title>
            <v-spacer />
            <span
                v-if="status"
                :style="{
                    color: statusColor(status),
                    'font-weight': 'bold',
                    'margin-right': '16px',
                }"
            >
                {{ $t(`incidents.statusLabels.${status}`) }}
            </span>
            <v-toolbar-items>
                <v-btn
                    v-if="onEdit"
                    icon
                    variant="plain"
                    elevation="0"
                    @click="onEdit"
                >
                    <v-icon>mdi-account-box-edit-outline</v-icon>
                </v-btn>
                <v-btn
                    v-if="onDelete"
                    icon
                    color="red"
                    variant="plain"
                    elevation="0"
                    @click="onDelete"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="py-0">
            <slot v-if="$slots.default" />
            <template v-else>
                <v-list density="compact">
                    <v-list-item
                        v-for="(item, index) in bullets"
                        :key="index"
                        density="compact"
                        class="wrap-text"
                    >
                        <v-list-item-title v-html="item"></v-list-item-title>
                    </v-list-item>
                </v-list>
            </template>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "BulletCard",
    props: {
        titleColor: {
            type: String,
            default: "white", // default for primary toolbar
        },
        toolbarColor: {
            type: String,
            default: "primary", // fallback/default color
        },
        /**
         * The title to display in the card header.
         * @type {String}
         */
        cardTitle: {
            type: String,
            required: true,
        },
        /**
         * An array of strings to display as bullet list items in the card content.
         * @type {Array}
         */
        bullets: {
            type: Array,
            required: true,
            default: () => [],
        },
        /**
         * An optional delete function.
         * @type {Function}
         */
        onDelete: {
            type: Function,
            default: null,
        },
        /**
         * An optional delete function.
         * @type {Function}
         */
        onEdit: {
            type: Function,
            default: null,
        },
        status: { type: String, default: null },
    },
    methods: {
        statusColor(s) {
            switch (s) {
                case "pending":
                    return "#FFFF00"; // yellow
                case "approved":
                    return "#4CAF50"; // Vuetify success
                case "declined":
                    return "#FF5252"; // Vuetify danger
            }
        },
    },
};
</script>
<style scoped>
.v-list-item-title {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    word-break: break-word;
}
</style>
